import * as types from './types';
import Quiz from '../../../helpers/request/quiz';
import * as merge from '../../../helpers/object/merge';
import * as internalStyleHelper from '../../../helpers/internalstyle';

const QuizRequest = new Quiz();

export const quizGet = ({ commit, rootState }, quizId) => {
  commit(types.QUIZ_SET_ID, quizId);

  QuizRequest.get(quizId)
    .then(response => {
      const styles = merge.deep({}, rootState.theme.active.styles, response.data.styles);

      commit(types.QUIZ_SET_STYLES, styles);
    });
};

export const quizUpdateStyle = ({ commit, state, dispatch }, { item, rule, value }) => {
  const styles = state.styles;

  commit(types.QUIZ_UPDATE_STYLE, { item, rule, value });

  const internalStyleElement = internalStyleHelper.getElement(item);

  if (internalStyleElement) {
    dispatch('boxUpdateContentBody', styles);
  }

  QuizRequest.put(state.id, { styles }, { showLoader: true })
    .then(response => commit(types.QUIZ_SET_STYLES, response.data.styles))
    .catch(() => commit(types.QUIZ_SET_STYLES, styles));
};

export const quizPreviewStyleChange = ({ commit, state }, { item, rule, value }) => {
  commit(types.QUIZ_UPDATE_STYLE, { item, rule, value });
};

export const quizSetStyle = ({ commit, state, dispatch }, presets) => {
  dispatch('boxUpdateContentBody', presets);

  QuizRequest.put(state.id, { styles: presets }, { showLoader: true })
    .then(response => commit(types.QUIZ_SET_STYLES, response.data.styles));
};

export const quizResetState = ({ commit }) => {
  commit(types.QUIZ_RESET_STATE);
};



/** WEBPACK FOOTER **
 ** ./src/store/modules/quiz/actions.js
 **/